export enum KeyboardEventType {
  KeyDown = 'keydown',
  KeyUp = 'keyup'
}
